import { TQuestion } from "../../../api/type"
import { formatQuestionStatus, formatVerificationStatus, getQuestionMeta } from "../utils/questionMeta"

type QuestionDetailSidebarProps = {
  question: TQuestion
  subjectLabel?: string | null
  levelLabels?: string[]
}

const QuestionDetailSidebar = ({
  question,
  subjectLabel,
  levelLabels,
}: QuestionDetailSidebarProps) => {
  const metaItems = getQuestionMeta(question, { subjectLabel, levelLabels }).filter(
    (item) => item.label !== "Status"
  )

  const statusClass =
    question.question_status === "published"
      ? "question-detail__status--published"
      : question.question_status === "archived"
        ? "question-detail__status--archived"
        : "question-detail__status--draft"

  return (
    <aside className="question-detail__sidebar">
      <h3>Metadata</h3>

      <ul className="question-detail__meta-list">
        {metaItems.map((item) => (
          <li className="question-detail__meta-item" key={item.label}>
            <span className="question-detail__meta-label">{item.label}</span>
            <span className="question-detail__meta-value">{item.value}</span>
          </li>
        ))}

        {question.verification_status && (
          <li className="question-detail__meta-item">
            <span className="question-detail__meta-label">Verification</span>
            <span className="question-detail__meta-value">
              {formatVerificationStatus(question.verification_status)}
            </span>
          </li>
        )}

        {question.question_status && (
          <li className="question-detail__meta-item">
            <span className="question-detail__meta-label">Status</span>
            <span className={`question-detail__status ${statusClass}`}>
              {formatQuestionStatus(question.question_status)}
            </span>
          </li>
        )}
      </ul>
    </aside>
  )
}

export default QuestionDetailSidebar
